<template>
    <div class="container-fluid">
        <br />
        <el-row :gutter="20">
            <el-col :span="16" :xs="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span> Ordenes </span>
                        <p v-show="false">Fechas: <range-selector /></p>
                    </div>
                    <el-table
                        ref="multipleTable"
                        :data="orders"
                        :show-summary="true"
                        :summary-method="calculate"
                        style="width: 100%"
                        id="orders-table"
                    >
                        <el-table-column
                            property="date"
                            label="Fecha"
                            width="120"
                        />
                        <el-table-column
                            property="clients"
                            label="Cliente"
                            width="120"
                        />
                        <el-table-column
                            property="company"
                            label="Empresa"
                            width="120"
                        />
                        <el-table-column
                            property="subtotal"
                            label="Facturado"
                            type="money"
                            width="120"
                        />

                        <el-table-column
                            property="tax"
                            label="ITBIS"
                            type="money"
                            width="120"
                        />

                        <el-table-column
                            property="retention"
                            label="Comisión"
                            type="money"
                            width="120"
                        />

                        <el-table-column
                            property="to_pay"
                            label="Total"
                            type="money"
                            width="120"
                        />
                        <el-table-column label="Operaciones" width="120">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="deleteOrder(scope.$index, orders)"
                                    >Eliminar</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="block">
                        <el-pagination
                            v-show="false"
                            @size-change="pageSizeChanged"
                            @current-change="paginate"
                            :current-page.sync="pagination.page"
                            :page-sizes="options.pageList"
                            :page-size="pagination.pageSize"
                            layout="total, prev, pager, next"
                            :total="pagination.total"
                        >
                        </el-pagination>
                    </div>
                </el-card>
            </el-col>

            <el-col :span="8" :xs="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span> Filtros </span>
                    </div>
                    <div class="text-right">
                        <el-form
                            ref="form"
                            :model="filters"
                            label-width="120px"
                        >
                            <el-form-item label="Activity name" v-show="false">
                                <el-input v-model="filters.text"></el-input>
                            </el-form-item>
                            <el-form-item label="Fechas">
                                <el-col :span="24">
                                    <el-date-picker
                                        type="date"
                                        placeholder="fecha inicio"
                                        v-model="filters.firstDate"
                                        style="width: 100%"
                                    ></el-date-picker>
                                    <el-date-picker
                                        type="date"
                                        placeholder="fecha final"
                                        v-model="filters.lastDate"
                                        style="width: 100%"
                                    ></el-date-picker>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="Pagados">
                                <el-switch v-model="filters.status"></el-switch>
                            </el-form-item>

                            <!-- <el-form-item>
              <el-button type="primary" @click="getOrders">Buscar</el-button>
            </el-form-item> -->
                        </el-form>
                    </div>
                </el-card>
                <br />

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span> Ganancia Total </span>
                    </div>
                    <div class="text-right">
                        <table class="table">
                            <tr>
                                <td>Total facturado(s):</td>
                                <td class="text-right">RD$ {{ subtotal }}</td>
                            </tr>
                            <tr>
                                <td>Impuesto facturados por ITBIS:</td>
                                <td class="text-right">RD$ {{ tax }}</td>
                            </tr>
                            <tr>
                                <td>Comisiones (-):</td>
                                <td class="text-right">RD$ {{ retention }}</td>
                            </tr>
                            <tr>
                                <td>Monto Avance (-):</td>
                                <td class="text-right">
                                    RD$ {{ invoice_payment }}
                                </td>
                            </tr>
                            <tr>
                                <td>Resumen de ventas</td>
                                <td class="text-right">RD$ {{ total }}</td>
                            </tr>
                        </table>
                        <a
                            href="#"
                            class="btn btn-success"
                            v-on:click="exportExcel()"
                            >Download Report.</a
                        >
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import moment from "moment";
import RangeSelector from "../components/RangeSelector";
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
    components: {
        RangeSelector,
    },

    data() {
        return {
            name: "OrderList",
            orders: [],
            limit: 400,
            dayTotal: 0,
            options: {
                pageList: [50, 100, 200],
            },
            q: "",
            filters: {
                text: "",
                firstDate: moment().startOf("month").toDate(),
                lastDate: moment().endOf("month").toDate(),
                status: false,
                range: false,
            },
            pagination: {
                page: 1,
                pageSize: 50,
            },
        };
    },

    computed: {
        total() {
            const total = this.orders.reduce((total, item) => {
                return (total +=
                    parseFloat(item.subtotal) -
                    parseFloat(item.retention) -
                    parseFloat(item.invoice_payment));
            }, 0);

            return Number(total).toFixed(2);
        },
        invoice_payment() {
            const invoice_payment = this.orders.reduce(
                (invoice_payment, item) => {
                    return (invoice_payment += parseFloat(
                        item.invoice_payment
                    ));
                },
                0
            );

            return Number(invoice_payment).toFixed(2);
        },

        tax() {
            const tax = this.orders.reduce((tax, item) => {
                return (tax += parseFloat(item.tax));
            }, 0);

            return Number(tax).toFixed(2);
        },

        retention() {
            const total = this.orders.reduce((total, item) => {
                return (total += parseFloat(item.retention));
            }, 0);

            return Number(total).toFixed(2);
        },

        subtotal() {
            const total = this.orders.reduce((total, item) => {
                return (total += parseFloat(item.subtotal));
            }, 0);

            return Number(total).toFixed(2);
        },
    },

    async mounted() {
        this.getParams();
        this.getOrders();
    },

    watch: {
        filters: {
            handler() {
                this.getParams();
                this.getOrders();
            },
            deep: true,
        },
        "$route.path"(path) {
            if (path == "orders") {
                this.getParams();
                this.getOrders();
            }
        },
    },

    methods: {
        deleteOrder(index, rows) {
            var order = rows[index];
            var message =
                "Quieres borrar la orden de " +
                order.clients +
                " con fecha " +
                order.date +
                " por un monto de " +
                order.subtotal;
            if (confirm(message)) {
                rows.splice(index, 1);
                return axios
                    .delete(
                        `${API_URL}/orders/` +
                            order.id +
                            "?shop_id=" +
                            this.$store.state.user.id
                    )
                    .then((res) => {
                        comsole.log(res);
                    })
                    .catch((err) => {
                        //this.fallBack()
                    });
            }
        },
        exportExcel() {
            var todayDate = new Date().toISOString().slice(0, 10);
            var wb = XLSX.utils.table_to_book(
                document.querySelector("#orders-table")
            );

            var wbout = XLSX.write(wb, {
                bookType: "xlsx",
                bookSST: true,
                type: "array",
            });
            try {
                FileSaver.saveAs(
                    new Blob([wbout], { type: "application/octet-stream" }),
                    todayDate + " Ordenes.xlsx"
                );
            } catch (e) {
                if (typeof console !== "undefined") console.log(e, wbout);
            }

            return wbout;
        },
        getParams() {
            let q = `q=(`;
            if (this.filters.firstDate && this.filters.lastDate) {
                const firstDate = moment(this.filters.firstDate).format(
                    "YYYY-MM-DD"
                );
                const lastDate = moment(this.filters.lastDate).format(
                    "YYYY-MM-DD"
                );
                q += `date:${firstDate}~${lastDate},`;
            }
            q += `status:${Number(this.filters.status)},shop_id:${
                this.$store.state.user.id
            }`;
            q += `)&`;
            this.q = q;
        },

        getOrders() {
            axios
                .get(`${API_URL}/orders/reports?${this.q}`)
                .then((res) => {
                    this.orders = res.data.map((row) => {
                        return row;
                    });
                })
                .catch((err) => {
                    //this.fallBack()
                });
        },

        getCreditLimit() {
            axios.get(`${API_URL}/employees/${this.employeeId}/limit_credit`);
        },

        getDayTotal() {
            const date = moment().format("YYYY-MM-DD");
            axios
                .get(
                    `${API_URL}/orders/employee-total/${this.employeeId}/${date}`
                )
                .then((res) => {
                    this.dayTotal = res.data.sum;
                });
        },

        pageSizeChanged() {},

        paginate() {},

        calculate(table) {
            const { columns, data } = table;
            const sums = [];

            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "Totales";
                    return;
                }

                if (index === 1) {
                    sums[index] = "";
                    return;
                }

                const values = data.map((item) =>
                    Number(item[column.property])
                );
                if (!values.every((value) => isNaN(value))) {
                    const sum = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);

                    sums[index] = "RD$ " + parseFloat(sum).toFixed(2);
                } else {
                    sums[index] = "";
                }
            });

            return sums;
        },
    },
};
</script>

<style>
th .el-checkbox {
    display: none;
}
</style>
